import { atom } from 'recoil';

export const atom_DownloadModeState = atom<boolean | undefined>({
	key: 'IsDownloadMode',
	default: false,
});
